import React from 'react'
import { EmptyBody, EmptyIcon, EmptyText } from './EmptyState.styles'

interface EmptyStateProps {
	/** Pre-sized zero-state icon (rendered in gold). Omit for the teaser variant. */
	icon?: React.ReactNode
	/** Friendly one-liner. The navigate CTA is the tile footer, so none is rendered here. */
	text: string
}

/**
 * The shared designed zero-state used by every bento tile: a centered icon over
 * a friendly line, sitting above the tile's navigate-to-section footer. Extracted
 * from `ItineraryTile` so all tiles read identically (review decision). Omitting
 * the icon yields the public-mode teaser body (copy only, no content leak).
 */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, text }) => (
	<EmptyBody>
		{icon != null && <EmptyIcon>{icon}</EmptyIcon>}
		<EmptyText>{text}</EmptyText>
	</EmptyBody>
)

export default EmptyState
